import { render, staticRenderFns } from "./CopyDashboard.vue?vue&type=template&id=2cb96806&scoped=true&"
import script from "./CopyDashboard.vue?vue&type=script&lang=js&"
export * from "./CopyDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CopyDashboard.vue?vue&type=style&index=0&id=2cb96806&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb96806",
  null
  
)

export default component.exports